import { useState } from 'react';
import { Paper, Tabs, Tab, Box } from '@mui/material';
import { Person, Settings } from '@mui/icons-material';
import ProfileTab from './Profile';
import SettingsTab from './Setting';
import ParentWrapper from '../../../components/ParentWrapper';
import {theme as colorTheme, palette} from "../../../Convoze.theme"


const primary = colorTheme('palette', 'primary').value;

export default function AccountManagement() {
  const [tab, setTab] = useState(0);

  return (
    <ParentWrapper>
      <Paper
        sx={{
          mb: 3,
          boxShadow: 0,
          border: 1,
          borderColor: 'grey.200',
          borderRadius: 2,
          overflow: 'hidden',
          '& .MuiTabs-indicator': { backgroundColor: primary, height: 3 },
          '& .MuiTab-root': {
            minHeight: 48,              
            py: 1,
            fontSize: '0.875rem',
            color: 'grey.600',
            '&.Mui-selected': { color: primary },
            '&:hover': { backgroundColor: `${primary}14` },
          },
          '& .MuiTouchRipple-root': { color: primary }, 
        }}
      >
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="fullWidth"
          textColor="inherit"
          TabIndicatorProps={{ sx: { backgroundColor: primary } }}
        >
          <Tab
            icon={<Settings sx={{ fontSize: 20, color: tab === 0 ? primary : 'inherit' }} />}
            label="Profile"
          />
          <Tab
            icon={<Person sx={{ fontSize: 20, color: tab === 1 ? primary : 'inherit' }} />}
            label="Settings"
          />
        </Tabs>
      </Paper>

      <Box>{tab === 0 ? <ProfileTab /> : <SettingsTab />}</Box>
    </ParentWrapper>
  );
}